import cn from 'classnames';
import { HTMLAttributes, useEffect, useRef, useState } from 'react';

import { IGalleryProgress } from './';

export function GalleryProgress(
  props: IGalleryProgress & HTMLAttributes<HTMLElement>,
) {
  const { stroke, colour, progress } = props;

  const ref = useRef(null);
  const [radius, setRadius] = useState(0);
  const [circumference, setCircumference] = useState(0);

  useEffect(() => {
    const r = () => {
      const nextRadius = ref.current.offsetHeight / 2;
      const normalizedRadius = nextRadius - 10;
      setRadius(nextRadius);
      setCircumference(normalizedRadius * 2 * Math.PI);
    };
    window.addEventListener('resize', r);
    r();
    return () => window.removeEventListener('resize', r);
  }, []);

  return (
    <div
      ref={ref}
      className={cn(
        'absolute -z-[1] left-0 w-full aspect-w-1 aspect-h-1 progress-ring hidden lg:block',
      )}
    >
      {radius > 0 && circumference > 0 && (
        <svg height="100%" width="100%" className={cn('-rotate-90')}>
          <circle
            className={cn('duration-[1600ms]')}
            stroke={colour}
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={circumference + ' ' + circumference}
            style={{
              strokeDashoffset:
                circumference - (progress / 100) * circumference,
            }}
            r={radius - 10}
            cx={radius}
            cy={radius}
          />
        </svg>
      )}
    </div>
  );
}
